import { Component, Vue } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import { CompleteNewPasswordActionParam } from '@/store/profile/types';
import { Validations } from 'vuelidate-property-decorators';
import { required, email, minLength, sameAs } from 'vuelidate/lib/validators';
import { CognitoUser } from '@aws-amplify/auth';
// @ts-ignore no d.ts
import Datepicker from 'vuejs-datepicker';
// @ts-ignore no d.ts
import { en, fr } from 'vuejs-datepicker/dist/locale';
import { Logger } from 'aws-amplify';
const logger = new Logger('Signup');

@Component({ components: { Datepicker } })
export default class Signup extends Vue {
  @State('locale', { namespace: 'profile' }) private locale!: string;
  @State('cognitoUser', { namespace: 'profile' }) private cognitoUser!: CognitoUser;
  @Action('completeNewPassword', { namespace: 'profile' }) private completeNewPassword!: (
    p: CompleteNewPasswordActionParam
  ) => Promise<CognitoUser>;

  loading = false;
  errorMessage = '';
  showPassword = false;
  capsWarning = false;

  form = {
    nom: '',
    prenom: '',
    entreprise: '',
    dateNaissance: '' as any, // le datepicker renvoie Date ou string selon config
    fonction: '',
    email: '',
    password: '',
    repeatPassword: '',
    cgu: false,
    newsletter: false,
  };

  @Validations()
  validations = {
    form: {
      nom: { required },
      prenom: { required },
      dateNaissance: { required },
      cgu: { required, checked: sameAs(() => true) },
      email: { required, email, emailAvailable: this.emailAvailable },
      password: {
        required,
        minLength: minLength(8),
        containsUppercase: (v: string) => /[A-Z]/.test(v || ''),
        containsLowercase: (v: string) => /[a-z]/.test(v || ''),
        containsNumber: (v: string) => /[0-9]/.test(v || ''),
      },
      repeatPassword: { sameAsPassword: sameAs('password') },
    },
  };

  get datepickerFormat(): string {
    return this.locale === 'en' ? 'yyyy-dd-MM' : 'dd-MM-yyyy';
  }
  get datepickerLocal() {
    return this.locale === 'en' ? en : fr;
  }

  get passwordLevel(): number {
    const v = this.form.password || '';
    let score = 0;
    if (v.length >= 8) score++;
    if (/[A-Z]/.test(v)) score++;
    if (/[a-z]/.test(v)) score++;
    if (/[0-9]/.test(v)) score++;
    if (/[^A-Za-z0-9]/.test(v)) score++;
    return score; // 0..5
  }

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }

  async onSubmit(e: Event) {
    e.preventDefault();
    this.$v.$touch();
    if (this.$v.$invalid) return;

    this.loading = true;
    this.errorMessage = '';
    try {
      const { userAttributes } = (this.cognitoUser as any).challengeParam || { userAttributes: {} };
      const email = this.form.email || userAttributes?.email;

      const payload: CompleteNewPasswordActionParam = {
        cognitoUser: this.cognitoUser,
        updateUser: {
          email,
          firstname: this.form.prenom,
          lastname: this.form.nom,
          birthday: new Date(this.form.dateNaissance),
          company: this.form.entreprise,
          function: this.form.fonction,
          acceptedCgu: this.form.cgu,
          acceptedNewslettre: this.form.newsletter,
          locale: this.$i18n.locale,
        },
        newPassword: this.form.password,
        family_name: this.form.nom,
        given_name: this.form.prenom,
      };

      await this.completeNewPassword(payload);
    } catch (error: any) {
      logger.warn({ error });
      this.errorMessage = error?.message || (this.$t('global.error') as string);
    } finally {
      this.loading = false;
    }
  }

  mounted() {
    const challenge = (this.cognitoUser as any)?.challengeParam;
    const preset = challenge?.userAttributes?.email;
    if (preset) this.form.email = preset;
  }

  // TODO: remplacer par un appel réel si nécessaire
  emailAvailable(): true {
    return true;
  }
}
